import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ThemeContextCustom } from './ThemeContext';
import { BrowserRouter } from 'react-router-dom';
import store, { persistor } from './redux/store';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <ThemeContextCustom>
       <Provider store={store}>
         <PersistGate loading={null} persistor={persistor}>
          <App />
         </PersistGate>
       </Provider>
    </ThemeContextCustom>
  </BrowserRouter>
);
reportWebVitals();
